import { render, staticRenderFns } from "./TextContainer.vue?vue&type=template&id=7912e5ae&scoped=true"
import script from "./TextContainer.vue?vue&type=script&lang=js"
export * from "./TextContainer.vue?vue&type=script&lang=js"
import style0 from "./TextContainer.vue?vue&type=style&index=0&id=7912e5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912e5ae",
  null
  
)

export default component.exports